<template>
    <DCard
        :title="__('orders.show.payment')"
        :main-title-has-slot="true"
        padding
    >
        <template #titleHasSlot>
            <DSwitch
                color="success"
                variant="3d"
                :disabled="isInLoadingState"
                :checked="showSection"
                @update:checked="showCardSection"
            />
        </template>
        <DRow v-if="showSection">
            <DCol col="6">
                <DFormRow
                    v-if="order.hasInvalidPaymentData"
                    :label="__('orders.show.hint')"
                >
                    <DTag
                        :label="__('orders.show.invalid_payment_data')"
                        :color="'danger'"
                    />
                </DFormRow>
                <DFormRow :label="__('orders.show.payment_method')">
                    <DTag
                        v-if="order.paymentMethod !== null"
                        :label="order.paymentMethod"
                    />
                </DFormRow>
                <DFormRow
                    v-if="order.iban !== null"
                    :label="__('orders.show.iban')"
                >
                    {{ order.iban }}
                </DFormRow>
                <DFormRow
                    v-if="order.bic !== null"
                    :label="__('orders.show.bic')"
                >
                    {{ order.bic }}
                </DFormRow>
                <DFormRow
                    v-if="order.accountOwner !== null"
                    :label="__('orders.show.account_holder')"
                >
                    {{ order.accountOwner }}
                </DFormRow>
                <DFormRow :label="__('orders.show.payment_term')">
                    <span v-if="order.paymentTerm">
                        {{ order.paymentTerm }} {{ __('customers.contracts.days') }}
                    </span>
                </DFormRow>
            </DCol>
        </DRow>
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { ref } from 'vue'

const props = defineProps({
    order: {
        type: Object,
        default () {
            return {}
        }
    },
    section: {
        type: String,
        default () {
            return ''
        }
    },
    showSection: {
        type: Boolean,
        default () {
            return true
        }
    },
    userListView: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const emit = defineEmits(['update-list'])

const columns = ref(props.userListView)

const form = useForm({
    columns: props.userListView
})

function showCardSection (value) {
    for (const column of columns.value) {
        if (column.column === props.section) {
            column.show_column = value
        }
    }

    form.columns = flattenColumns(columns.value)

    form.post(route('settings.list-view-settings.store'))

    emit('update-list', columns.value)
}

function flattenColumns (columns) {
    if (columns.length === 0) {
        return {}
    }

    const result = {}

    for (const [key, column] of Object.entries(columns)) {
        result[key] = JSON.parse(JSON.stringify(column))
    }

    return result
}
</script>

<style scoped>

</style>
